module.exports = __webpack_public_path__ + "644824bea842069421c778b7cfb153d3.svg";